<template>
  <div class="tree-choice-body">
    <div class="tree-chioce-main">
      <div
        v-for="node of treeData"
        :key="node.id"
        @click.stop="chooseNode(node)"
        :class="active === node.id ? 'active' : ''"
      >
        <div class="choose-tem">
          <span>{{node.name}}</span>
        </div>
      </div>
    </div>
    <template v-if="children && children.length">
      <div>
        <tree
        :treeData="children"
        :chooseList="chooseList"
        >
        </tree>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'tree',
  props: {
    treeData: {
      type: Array,
      required: true,
      default: () => {}
    },
    chooseList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      tree: null,
      level: 0,
      children: [],
      active: ''
    }
  },
  created () {
    const parent = this.$parent
    if (parent.isTree) {
      this.level = 1
      this.tree = parent
    } else {
      this.level = parent.level + 1
      this.tree = parent.tree
    }
  },
  methods: {
    chooseNode (node) {
      this.active = node.id
      this.children = []
      this.children = node.children || []
      this.tree.$emit('choose', node)
    }
  }
}
</script>
<style lang="stylus" scoped>
.tree-choice-body
  color #333
  display flex
  .tree-chioce-main
    overflow-y scroll
    width 3rem
    border-right 1px solid #DFDFDF
    height 6.5rem
    padding 0 0.2rem
    .active
      color #409EFF
    input
      appearance auto
      width 0.2rem
      height 0.2rem
      line-height 0.7rem
</style>
